import type {
  BusinessAddressFormValues,
  OfficeAddressFormValues,
} from '~domains/partner-application/entities/application';

export const businessAddressToOfficeAddress = (
  businessAddress: BusinessAddressFormValues
): OfficeAddressFormValues => {
  return {
    sameAsRegisteredAddress: true,
    country: businessAddress.country,
    region: businessAddress.region,
    province: businessAddress.province,
    cityOrMunicipality: businessAddress.cityOrMunicipality,
    postalCode: businessAddress.postalCode,
    barangay: businessAddress.barangay,
    streetAndHouse: businessAddress.streetAndHouse,
    unitAndFloor: businessAddress.unitAndFloor,
  };
};
